// extracted by mini-css-extract-plugin
export var indeterminate = "_4q-6";
export var md = "_4q-5";
export var semantic = "_4q-7";
export var sm = "_4q-4";
export var text = "_4q-8";
export var toggleControl = "_4q-0";
export var toggleInput = "_4q-1";
export var toggleSwitch = "_4q-2";
export var xs = "_4q-3";